import { render, staticRenderFns } from "./FirmaTanimliAlanlar.vue?vue&type=template&id=58a51c99&"
import script from "./FirmaTanimliAlanlar.vue?vue&type=script&lang=js&"
export * from "./FirmaTanimliAlanlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports